import { useSyncExternalStore } from 'react'

const fields = ['organization_id', 'q', 'sort', 'change', 'member', 'membership_level_id', 'cursor']

function subscribe(restore: () => void) {
  window.addEventListener('popstate', restore)
  return () => window.removeEventListener('popstate', restore)
}

export function useRegistrationQuery() {
  const search = useSyncExternalStore(subscribe, () => window.location.search)
  const params = new URLSearchParams(search)
  const update = (key: string, value: string) => {
    const next = new URLSearchParams(window.location.search)
    if (key !== 'cursor') next.delete('cursor')
    if (value) next.set(key, value)
    else next.delete(key)
    window.history.pushState({}, '', `/reports/event-registrations?${next}`)
    window.dispatchEvent(new PopStateEvent('popstate'))
  }
  return { params, update }
}

export function registrationQuery(params: URLSearchParams, exportView = false) {
  const query = new URLSearchParams()
  for (const key of fields) {
    const value = params.get(key)
    if (value && !(exportView && key === 'cursor')) query.set(key, value)
  }
  return query.toString()
}

export type RegistrationQueryControls = {
  params: URLSearchParams
  update: (key: string, value: string) => void
}
